import { useFormContext } from "@/app/components/formContext/formcontext";
import VehicleCardRural from "@/app/components/ServicesComponents/RuralCard";
import {
  CustomPaging,
  SampleNextArrow,
  SamplePrevArrow,
} from "@/app/components/swipersComponents";
import { useEffect, useState } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick-theme.css";
import "slick-carousel/slick/slick.css";
import { withServicesLayout } from "@/pages/_layoutService";

function Taxista() {
  const { setOptions, setInputValue } = useFormContext();
  const [currentIndex, setCurrentIndex] = useState(0);

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1140,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 770,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
    autoplay: true,
    autoplaySpeed: 5000,
    beforeChange: (oldIndex: number, newIndex: number) => {
      setCurrentIndex(newIndex);
    },
    customPaging: (index: number) => {
      return (
        <CustomPaging
          key={"pagging-taxista" + index}
          index={index}
          currentIndex={currentIndex}
        />
      );
    },
    nextArrow: <SampleNextArrow />,
    prevArrow: <SamplePrevArrow />,
  };
  const cars = [
    {
      imageSrc:
        "https://sablobsitestoyotaprd.blob.core.windows.net/images/LP-VD/Taxi/corolla.png",
      name: "COROLLA",
      details: "",
      year: "2024/2024",
    },
    {
      imageSrc:
        "https://sablobsitestoyotaprd.blob.core.windows.net/images/LP-VD/Taxi/corolla_cross.png",
      name: "COROLLA CROSS",
      details: "",
      year: "2024/2024",
    },
  ];
  const models = cars.map(
    (m) => `${m.name} ${m.details == "" ? "" : "-"} ${m.details}`,
  );

  useEffect(() => {
    setOptions([...models]);
  }, []);
  return (
    <>
      <div className="w-full text-zinc-800 p-3">
        <div className="w-full  lg:h-40 mt-5 lg:p-3 ">
          <h1 className="text-[40px]  text-black leading-[57.6px] max-md:max-w-full max-md:text-4xl">
            Taxista
          </h1>
          <div className="w-16 border-b-2 ml-1 border-red-600 " />
        </div>
        <p className="mt-10">
          Se você é taxista e procura um veículo confiável e eficiente para
          enfrentar as demandas da cidade, a Toyota tem a solução ideal para
          você. Com nosso programa de venda direta para taxistas, oferecemos
          condições especiais e benefícios exclusivos para ajudá-lo a adquirir o
          carro perfeito para o seu trabalho.
          <br />
          <br />
          Os veículos Toyota são construídos com os mais altos padrões de
          qualidade e segurança, proporcionando tranquilidade e confiança em
          cada viagem tanto para o motorista quanto para os passageiros. Você
          pode confiar na Toyota para oferecer um carro que atenda às suas
          necessidades de táxi, proporcionando confiabilidade e tranquilidade
          durante cada corrida.
          <br />
          <br />
          Nossa equipe de vendas diretas está preparada para oferecer orientação
          especializada e assistência personalizada em todas as etapas do
          processo de compra. Estamos comprometidos em ajudá-lo a encontrar o
          veículo certo que atenda às suas necessidades específicas como
          taxista.
        </p>
        {/*<div className="flex flex-col gap-5 lg:hidden mb-20">
          <Slider {...settings}>
            {cars.map((vehicle, index) => (
              <div key={`taxista-mobile-${vehicle.name}-${index}`}>
                <VehicleCardRural
                  key={`taxista-card-${vehicle.name}-${index}`}
                  imageSrc={vehicle.imageSrc}
                  name={vehicle.name}
                  details={vehicle.details}
                  year={vehicle.year}
                  onClick={() => setInputValue(models[index])}
                />
              </div>
            ))}
          </Slider>
        </div>*/}
        <h2 className="text-2xl py-5">
          Quais documentos são necessários para inclusão do pedido?
        </h2>
        <p className="pb-5">
          - CNH em nome do Titular da Placa de Taxi;
          <br />
          - Alvará vigente expedido pela Prefeitura Municipal;
          <br />
          - Comprovação de endereço vinculado ao Município da Licença de TAXI;
          <br />
          - Isenção de IPI e ICMS (se houver) com validade igual ou superior ao
          prazo estabelecido pelo fabricante para o faturamento;
          <br />- Declaração ou Decreto Municipal que confirme o aceite do
          modelo ou cor do veículo a ser adquirido. (Alguns municípios
          estabelecem regras quanto ao modelo e cor, por isso, é importante a
          apresentação do documento a fim de evitar suspensão do emplacamento
          após a emissão da NF).
        </p>
      </div>
    </>
  );
}
export default withServicesLayout(Taxista);
export { getServerSideProps } from "@/pages/_layoutService";
